import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import Button from '../../../../UI/Button/Button';
import {hideOverlay} from '../../../actions/overlay-actions';
import Translation from '../../../lang/Translation';
import CheckoutOverlay from '../CheckoutOverlay';

const useStyles = createUseStyles({
  residentIdOverlay: {
    fontSize: 14,
  },
  buttonContainer: {
    marginTop: 40,
  },
});

export function ResidentIdDeliveryDescriptionOverlay(props) {
  const classes = useStyles();
  return (
    <CheckoutOverlay
      popup
      className={classes.residentIdOverlay}
      data-test="ResidentIdDeliveryDescriptionOverlay"
      title="delivery.method.faster.link"
    >
      <div data-test="ResidentIdDeliveryDescriptionOverlay__text">
        <Translation>delivery.method.residentId.overlay.text</Translation>
      </div>
      <div
        className={classes.buttonContainer}
        data-test="ResidentIdDeliveryDescriptionOverlay__buttonContainer"
      >
        <Button
          id="ResidentIdDeliveryDescriptionOverlay__closeButton"
          className="ResidentIdDeliveryDescriptionOverlay__closeButton"
          primary
          fullWidth
          onClick={props.hideOverlay}
        >
          <Translation>checkout.close.button</Translation>
        </Button>
      </div>
    </CheckoutOverlay>
  );
}

ResidentIdDeliveryDescriptionOverlay.propTypes = {
  hideOverlay: PropTypes.func,
};

export default connect(null, {hideOverlay})(ResidentIdDeliveryDescriptionOverlay);
